import * as React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

interface Props {
  percentage: number;
  widthPx?: number;
  color?: string;
}

const VerticalProgressBar: React.FC<Props> = ({ percentage, widthPx = 20, color }) => {
  const theme = useTheme();
  const barColor = color || theme.palette.primary.main;

  return (
    <Box
      sx={{
        width: widthPx,
        height: "100%",
        bgcolor: "#F5F5F5",
        position: "relative",
        borderRadius: "1px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: `${percentage}%`,
          bgcolor: barColor,
        }}
      />
    </Box>
  );
};

export default VerticalProgressBar;
